var exports = module.exports = {
  SoundTouch: require('./src/js/soundtouch'),
  SimpleFilter: require('./src/js/filter')
}



//////////////////
// WEBPACK FOOTER
// ./~/soundtouch-js/index.js
// module id = 2058
// module chunks = 3